<template>
    <img v-if="img !== null" :src="img" @error="handleError"/>
</template>

<script>
export default {
    name: "SiteIcon",
    props: ['url'],
    data() {
        return {
            img: null,
            hostMap: {
                'jd.com': 'https://www.jd.com/favicon.ico',
                'openai.com': 'https://openaiapi-site.azureedge.net/public-assets/d/13531e660e/favicon.png',
                'cnki.net': '/static/sites/zhiwang.jpg',
                'drugfuture.com': '/static/sites/yaowu.jpg',
                'cancer123.com': '/static/sites/cancer123.png',
                'baidu.com': 'https://www.baidu.com/favicon.ico',
                'cancer.gov': 'https://ocg.cancer.gov/sites/all/themes/new_ocg/favicon.ico',
                'mvwchina.com': '/static/sites/mvwchina.png',
                'deepl.com': 'https://static.deepl.com/img/logo/DeepL_Logo_darkBlue_v2.svg',
            },
            domainMap: {
                'www.nhc.gov.cn': '/static/sites/nhc.jpeg',
            },
            urlMap: {
                'https://www.ncbi.nlm.nih.gov/geo/': '/static/sites/GEO.gif',
                'https://www.cancer.gov/about-nci/organization/ccg/research/structural-genomics/tcga': '/static/sites/TCGA.jpg',
            },
            domain: '',
        }
    },
    created() {
        if(this.urlMap[this.url] !== undefined) {
            this.$nextTick(() => {
                this.img = this.urlMap[this.url]
            });
            return;
        }

        let cutIndex = this.url.indexOf('/', 8)
        let host
        if(cutIndex > 0) {
            host = this.url.substr(0, cutIndex)
        } else {
            host = this.url
        }

        let domain = '';
        let protocolIndex = host.indexOf('://')
        if(protocolIndex > 0)
            domain = host.substr(protocolIndex + 3);


        let parts = domain.split('.')
        this.domain = domain
        let topDomain = parts[parts.length - 2] + '.' + parts[parts.length - 1];
        // console.log(domain)

        if(this.domainMap[domain] !== undefined) {
            this.$nextTick(() => {
                this.img = this.domainMap[domain];
            })
            return;
        }

        if(this.hostMap[topDomain] !== undefined) {
            this.$nextTick(() => {
                this.img = this.hostMap[topDomain]
            })
            return;
        }

        // if(localStorage.getItem("no_icon_" + domain) === '1') {
        //     this.img = '/static/default-site.png'
        //     return
        // }

        this.img = host + '/favicon.ico'
    },
    methods: {
        handleError() {
            this.img = '/static/default-site.png'
            // localStorage.setItem("no_icon_" + this.domain, '1');
        }
    }
}
</script>

<style scoped>
img {
    float:left; width: 15px; height: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/SiteIcon.vue